import { STATIC_STRINGS } from "../../../../../utils/Constants";
import GenericSelect from "../../../../../common/GenericSelect";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { updateProctoring } from "../../../../../store/steps/stepFourSlice";

const ProctoringSelect = () => {
  const dispatch = useDispatch();
  const proctoring = useSelector(
    (state: RootState) => state.stepFour.proctoring
  );

  return (
    <div className="mt-4 flex items-center">
      <div className="font-semibold mr-2">{STATIC_STRINGS.PROCTORING}</div>
      <GenericSelect
        className="w-20"
        value={proctoring ? STATIC_STRINGS.YES : STATIC_STRINGS.NO}
        onChange={(e) => {
          dispatch(updateProctoring(e.target.value === STATIC_STRINGS.YES));
        }}
        options={[
          { label: STATIC_STRINGS.YES, value: STATIC_STRINGS.YES },
          { label: STATIC_STRINGS.NO, value: STATIC_STRINGS.NO },
        ]}
      />
    </div>
  );
};
export default ProctoringSelect;
